<script type="text/babel">
    export default {
        name: 'components-style-index',
        render: function (createElement) {
            return createElement('style', this.$slots.default)
        },
        watch: {},
        props: {},
        data() {
            return {}
        },
        methods: {},
        computed: {},
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        mixins: [],
        components: {}
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
